import styled, { css } from 'styled-components';
import { FlexBox, MEDIA } from '@brg/ui';
import { FC } from 'react';
import { useLockBodyScroll } from '@brg/ui';
import { CoreContainer } from '../../../core';
import { LayoutConst } from 'core/modules';

export const PageLayout = styled(FlexBox)`
    flex-direction: column;
    margin: 0 auto;
`;

export const OverBackLayout = styled.div`
    position: static;
    z-index: 100;
    top: 40px;
    bottom: 0;
    height: auto;
    right: 0;
    left: 0;
    background: ${(p) => p.theme.skeleton.background};
`;

export const Overback: FC<React.PropsWithChildren<{ state: boolean; component?: any; className?: any }>> = ({ state, component, children }) => {
    const CMP = component;
    useLockBodyScroll(state);
    if (!state) return null;

    // временный фикс
    return (
        <OverBackLayout>
            <CoreContainer>{CMP ? <CMP isLoading={true} /> : children}</CoreContainer>
        </OverBackLayout>
    );
};

interface IPageViewportLayout {
    vtype?: string;
    skipReducedVersion?: boolean;
    isDiscipline?: boolean;
}

export const PageViewportLayout = styled(FlexBox)<IPageViewportLayout>`
    width: 100%;
    max-width: ${ ({ vtype }) => (['t-shape', 'fixed-ratio-large', 'free-type'].includes(String(vtype)) ? '100%' : vtype === 'fluid' ? '1440px' : vtype === 'fluid-wide' ? '1920px' : '1152px') };
    flex-direction: column;
    // margin: ${({offsetTop}) => offsetTop === 0 ? 0 : offsetTop || 16}px auto 93px auto; //prev
    margin: ${({offsetTop}) => offsetTop === 0 ? 0 : offsetTop || 16}px auto 64px auto;

    ${({vtype}) => vtype === 'fixed-ratio-small' && 'margin-top: 24px;'}

    color: ${p => p.theme.competition.mainText};
    
    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        max-width: ${ ({ vtype }) => (['fixed-ratio-small'].includes(String(vtype)) ? '888px' : ['fixed-ratio-large', 't-shape', 'free-type'].includes(String(vtype)) ? '100%' : vtype === 'fluid' ? '1440px' : vtype === 'fluid-wide' ? '1920px' : '1152px')};
    }

    @media (max-width: ${LayoutConst.screen.l_12}px) {
        max-width: ${ ({ vtype }) => (['t-shape', 'fixed-ratio-large', 'free-type'].includes(String(vtype)) ? '100%' : [ 'fixed-ratio-small'].includes(String(vtype)) ? '888px' : vtype === 'fluid' ? '1440px' : vtype === 'fluid-wide' ? '1920px' : '940px') };
        //@ts-ignore
        // max-width: ${ ({ vtype, skipReducedVersion }) => (skipReducedVersion ? '100%' : vtype === 'fluid' ? '1440px' : vtype === 'fluid-wide' ? '1920px' : '1152px')};
    }

    @media ${MEDIA.TABLET} {
        ${({vtype}) => vtype === 'fixed-ratio-small' && 'margin-top: 0;'}
    }

    @media ${MEDIA.MOBILE} {
        ${({vtype}) => vtype === 'fixed-ratio-small' && 'margin-top: 16px;'}
    }

    a {
        color: inherit;

        &:hover {
            text-decoration: none;
            color: ${ (p) => p.theme.teamLinkHover };
        }
    }

    .a-green {
        color: ${ (p) => p.theme.teamLink };

        &:hover {
            text-decoration: none;
            color: ${ (p) => p.theme.teamLinkHoverAccent };
        }
    }

    @media (max-width: 940px) {
        max-width: 100vw;
        margin-left: ${({isDiscipline}) => isDiscipline ? 'auto' : 0};
        margin-right: ${({isDiscipline}) => isDiscipline ? 'auto' : 0};
    }
        ${({ isDiscipline }) => isDiscipline && css`
          @media (max-width: ${LayoutConst.screen.s}px) {
                margin-left: 15px;
                margin-right: 15px;
            }
        `}
    
    @media (max-width: 743px) {
        margin-bottom: 48px;
    }
`;
import styled, { css } from 'styled-components';
import { FlexBox, MEDIA } from '@brg/ui';
import { FC } from 'react';
import { useLockBodyScroll } from '@brg/ui';
import { CoreContainer } from '../../../core';
import { LayoutConst } from 'core/modules';

export const PageLayout = styled(FlexBox)`
    flex-direction: column;
    margin: 0 auto;
`;

export const OverBackLayout = styled.div`
    position: static;
    z-index: 100;
    top: 40px;
    bottom: 0;
    height: auto;
    right: 0;
    left: 0;
    background: ${(p) => p.theme.skeleton.background};
`;

export const Overback: FC<React.PropsWithChildren<{ state: boolean; component?: any; className?: any }>> = ({ state, component, children }) => {
    const CMP = component;
    useLockBodyScroll(state);
    if (!state) return null;

    // временный фикс
    return (
        <OverBackLayout>
            <CoreContainer>{CMP ? <CMP isLoading={true} /> : children}</CoreContainer>
        </OverBackLayout>
    );
};

interface IPageViewportLayout {
    vtype?: string;
    skipReducedVersion?: boolean;
    isDiscipline?: boolean;
}

export const PageViewportLayout = styled(FlexBox)<IPageViewportLayout>`
    width: 100%;
    max-width: ${ ({ vtype }) => (['t-shape', 'fixed-ratio-large', 'free-type'].includes(String(vtype)) ? '100%' : vtype === 'fluid' ? '1440px' : vtype === 'fluid-wide' ? '1920px' : '1152px') };
    flex-direction: column;
    // margin: ${({offsetTop}) => offsetTop === 0 ? 0 : offsetTop || 16}px auto 93px auto; //prev
    margin: ${({offsetTop}) => offsetTop === 0 ? 0 : offsetTop || 16}px auto 64px auto;

    ${({vtype}) => vtype === 'fixed-ratio-small' && 'margin-top: 24px;'}

    color: ${p => p.theme.competition.mainText};
    
    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        max-width: ${ ({ vtype }) => (['fixed-ratio-small'].includes(String(vtype)) ? '888px' : ['fixed-ratio-large', 't-shape', 'free-type'].includes(String(vtype)) ? '100%' : vtype === 'fluid' ? '1440px' : vtype === 'fluid-wide' ? '1920px' : '1152px')};
    }

    @media (max-width: ${LayoutConst.screen.l_12}px) {
        max-width: ${ ({ vtype }) => (['t-shape', 'fixed-ratio-large', 'free-type'].includes(String(vtype)) ? '100%' : [ 'fixed-ratio-small'].includes(String(vtype)) ? '888px' : vtype === 'fluid' ? '1440px' : vtype === 'fluid-wide' ? '1920px' : '940px') };
        //@ts-ignore
        // max-width: ${ ({ vtype, skipReducedVersion }) => (skipReducedVersion ? '100%' : vtype === 'fluid' ? '1440px' : vtype === 'fluid-wide' ? '1920px' : '1152px')};
    }

    @media ${MEDIA.TABLET} {
        ${({vtype}) => vtype === 'fixed-ratio-small' && 'margin-top: 0;'}
    }

    @media ${MEDIA.MOBILE} {
        ${({vtype}) => vtype === 'fixed-ratio-small' && 'margin-top: 16px;'}
    }

    a {
        color: inherit;

        &:hover {
            text-decoration: none;
            color: ${ (p) => p.theme.teamLinkHover };
        }
    }

    .a-green {
        color: ${ (p) => p.theme.teamLink };

        &:hover {
            text-decoration: none;
            color: ${ (p) => p.theme.teamLinkHoverAccent };
        }
    }

    @media (max-width: 940px) {
        max-width: 100vw;
        margin-left: ${({isDiscipline}) => isDiscipline ? 'auto' : 0};
        margin-right: ${({isDiscipline}) => isDiscipline ? 'auto' : 0};
    }
        ${({ isDiscipline }) => isDiscipline && css`
          @media (max-width: ${LayoutConst.screen.s}px) {
                margin-left: 15px;
                margin-right: 15px;
            }
        `}
    
    @media (max-width: 743px) {
        margin-bottom: 48px;
    }
`;
